import React, { useState, useEffect } from "react";
import { useAppSelector } from "../store/types";
import HeaderCrate from "./HeaderCreate";
import ContentCrate from "./ContentCrate";
import Navbar from "./Navbar";
import Footer from "../components/SbuxFooter";
import SbuxLoadingIndicator from "../components/SbuxLoadingIndicator";
import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import { default as theme } from "../themes/sbux";
import { getConnectedInstanceSelector } from "../selectors/userInstanceSelector";
import { getTabsStatusSelector } from "../selectors/tabsSelector";
import { getCcpInitializedSelector } from "../selectors/ccpSelector";
import { SnackbarProvider } from "notistack";
import styles from "./styles";
import useCss from "../hooks/useCss";

interface Props {
  children?: React.ReactNode;
}

const CrateLayout = ({ children }: Props) => {
  const classes = useCss(styles);
  const connectedInstance = useAppSelector(getConnectedInstanceSelector);
  const tabsStatus = useAppSelector(getTabsStatusSelector);
  const isCcpInitialized = useAppSelector(getCcpInitializedSelector);
  const [instanceSelection, setInstanceSelection] = useState(false);

  useEffect(() => {
    if (!instanceSelection && !!connectedInstance) {
      setInstanceSelection(true);
    }
  }, [connectedInstance]);

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box className={classes.crateRoot}>
          <Box className={classes.crateNavbar}>
            <Navbar />
          </Box>

          <SbuxLoadingIndicator
            isLoading={isCcpInitialized && tabsStatus !== "enabled"}
          />

          <Box className={classes.crateBody}>
            <Box className={classes.crateLeft}>
              <HeaderCrate />
            </Box>
            <Box className={classes.crateRight}>
              <ContentCrate />
              {children}
            </Box>
          </Box>

          <Box className={classes.crateFooter}>
            {instanceSelection && <Footer />}
          </Box>
        </Box>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default CrateLayout;
